// 事件车, 解决组件之间传值 函数调用问题
import Vue from 'vue';
export default new Vue();




// WEBPACK FOOTER //
// ./src/components/libs/eventBus.js